import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { vMaska } from "@ui-kit/directives";
import { i18n } from "./app/i18n";
import { router } from "./app/router";
import { default as App } from "./App.vue";

const app = createApp(App);
const pinia = createPinia();

app.use(router);
app.use(VueQueryPlugin, { enableDevtoolsV6Plugin: true });
app.use(pinia);
app.use(i18n);
app.directive("maska", vMaska);

app.mount("#shopflow_go_ui");
